import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {  Checkbox, FormGroup, Hidden, InputLabel,  MenuItem,  Select,  TextField } from '@material-ui/core';
import { Button, Backdrop, ListItemButton, CircularProgress } from '@mui/material';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid'
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';


import ModalProcedure from './ModalProcedure';
import ModalDiagnoses from './ModalDiagnoses';
import ModalTreatment from './ModalTreatment';
import ModalReferral from './ModalReferral';
import {v4 as uuid} from "uuid"; 
import moment from 'moment';
import 'moment/locale/es';

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/history/create";

function getRealAge(dateString) {

    if(!dateString || dateString == null) {
        return "";
    }
var starts = moment(dateString);
var ends   = moment();
var duration = moment.duration(ends.diff(starts));

return duration.years() + " años "+ duration.months()  +" meses";
}

export default function UpdateHistoryMedical(props) {
   
    const [open, setOpen] = React.useState(false);
    const [openReferrals, setOpenReferrals] = React.useState(false);
    const [openTreatments, setOpenTreatments] = React.useState(false);
    const [openProcedures, setOpenProcedures] = React.useState(false);
    
    const [openLoader, setOpenLoader] = React.useState(false);

    const handleOpen = () =>  {
        setOpen(true);
    }
    const handleOpenReferrals = () =>  {
        setOpenReferrals(true);
    }
    const handleOpenTreatments = () =>  {
        setOpenTreatments(true);
    }
    const handleOpenProcedures = () =>  {
        setOpenProcedures(true);
    }

    const handleClose = () => {
        setOpen(false);
        setOpenReferrals(false);
        setOpenTreatments(false);
        setOpenProcedures(false);
    }

    const addDiagnosis = (diagnosis) => {
        //diagnosis.id = uuid();
       // console.log(JSON.stringify(diagnosis));
        if(body.diagnoses.length > 0 ){
            body.diagnoses = body.diagnoses.concat(diagnosis);
          } else {
            body.diagnoses.push(diagnosis);
          }
        setOpen(false);
    }

    const addReferrals = (referral) => {
        referral.id = uuid();
        
        if(body.referrals.length > 0 ){
            body.referrals = body.referrals.concat(referral);
          } else {
            body.referrals.push(referral);
          }
        setOpenReferrals(false);
    }

    const addTreatments = (treatment) => {
        treatment.id = uuid();
      if(body.treatments.length > 0 ){
        body.treatments = body.treatments.concat(treatment);
      } else {
        body.treatments.push(treatment);
      }
        setOpenTreatments(false);
    }

    const addProcedure = (procedure) => {
        procedure.id = uuid();
        if(body.procedures.length > 0 ){
            body.procedures = body.procedures.concat(procedure);
          } else {
            body.procedures.push(procedure);
          }
         setOpenProcedures(false);
    }

    const useStyles = makeStyles((theme) => ({
      
        textRadioButton: {
            fontSize: '18',
        }
    }));

  
    const handleChangeDate = (newValue) => {
        setBody({
            ...body,
            ["assessmentDate"]: newValue
        })
    };

      //console.log("Reading evolutions: -->> " + JSON.stringify(props.affiliateInfo) + " read index " + props.indexEvolution)
    const [body, setBody] = useState(props.affiliateInfo.evolutions[props.indexEvolution]);
    
    const handleChangeRadioGroup = e => {
        const { id, name, value } = e.target;
        let barthelScore = Number(body.barthel.score)
        if(barthelScore === -1) {
            barthelScore = 0;
        }
        let score = barthelScore - Number(body["barthel"][name]) + Number(value); //arreglar
        setBody(body => ({
            ...body,
        
            ["barthel"]: {
              ...body["barthel"],
        
                    [name]: Number(value),
                    ["score"]: score
                 
            }
          }));
    };

    const [evolutionToCut, setPreviousEvolutions] = useState(props.affiliateInfo.evolutions);
    const previousEvolutions = evolutionToCut.filter(evolution => evolution.id != null);
    const [indexEvolution, setIndexEvolution] = useState(-1);
    const changeOfEvolutions = e => {
        const {value } = e.target;
        //console.log("value of evolutions es ____ " + value);
        setIndexEvolution(value);
        let bodyToUse;
        if(value == -1) {
            bodyToUse = props.affiliateInfo.evolutions[props.indexEvolution];
        } else {
            bodyToUse = props.affiliateInfo.evolutions[value];
        }
        bodyToUse.useBart1el = Number(bodyToUse.barthel.score) != -1;
        setBody(bodyToUse);
    }

    const activeTableBarthel = e => {
        if (e.target.checked) {
            if(Number(body.barthel.score) === -1) {
                body.barthel.score = 0;
            }
        } else {
            body.barthel.score = -1;
            body.barthel.retrete = 0;
            body.barthel.move = 0;
            body.barthel.escalera = 0;
            body.barthel.orina = 0;
            body.barthel.comer = 0;
            body.barthel.dressed = 0;
            body.barthel.heces = 0;
            body.barthel.bath = 0;
            body.barthel.translate = 0;
            body.barthel.cleanPersonal= 0;
        }
        setBody({
          ...body,
          [e.target.name]: e.target.checked
      })
    }

    const  deleteItem = ( name, value) => {
        setBody({
			...body,
			[name]: value
		})
    }
    const handleChangeListItem = e => {
    const { id, name, value } = e.target;
    setBody({
        ...body,
        [name]: value
    })
};
    const handleChange = e => {
        const { id, name, value } = e.target;
        //console.log("id " + id + " name " + name + " values " + value + " e.target " + e.target.dataset.txt);
        setBody(body => ({
          ...body,
      
          [id]: {
            ...body[id],
      
                  [name]: value
               
          }
        }));

        if (name === 'size' && body.vitalSigns.weight){
            let transformSize = (value/100);
            let powSize =  Math.pow(transformSize, 2)
            let imc = body.vitalSigns.weight / powSize;
            
            setBody(body => ({
                ...body,
            
                [id]: {
                  ...body[id],
            
                        ["imc"]: imc
                     
                }
              }));
        }
      };

    
      const onSubmit = (props, redirect) => {
        if(indexEvolution != -1) {
            return;
        }
        props.affiliateInfo.medicalTeam = props.user;
        //console.log("medicooo " + JSON.stringify(props.user))
        props.affiliateInfo.evolutions[props.indexEvolution] = body;
        console.log("Saving submit: " + JSON.stringify(props.affiliateInfo))
        props.setAffiliate(props.affiliateInfo);
       
        setOpenLoader(true);
        axios.post(url, props.affiliateInfo).then(response => { 
            //console.log(response.data);
            if(redirect){
                props.changeMenu(12)
            }
            setOpenLoader(false);
          });
	 }

     const columns = [
        { field: 'id', headerName: 'Codigo', width: 140 },
        { field: 'description', headerName: 'Diagnóstico', width: 300 },
        { field: 'classDiagnosis', headerName: 'Clase diagnóstico', width: 240 },
        { field: 'typeDiagnosis', headerName: 'Tipo diagnóstico', width: 240 },
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                        body.diagnoses = body.diagnoses.filter(diagnose => diagnose.id != params.row.id);
                        deleteItem("diagnoses", body.diagnoses);

                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];

    //"Cada " +item.every +" " + item.everyTime+ " durante "+ item.duration + " " + item.durationTime ]
    const columnsTreatments = [
        { field: 'description', headerName: 'Medicamento',  headerAlign: 'center', width: 330 },
        { field: 'quantity', headerName: 'Cantidad',  headerAlign: 'center', align: 'center', width: 140 },
        { field: 'frecuencia', headerName: 'Frecuencia',  headerAlign: 'center', width: 260, valueGetter: (params) =>
        ` Cada  ${params.row.every || ''} ${params.row.everyTime || ''}  durante 
          ${params.row.duration || ''}  ${params.row.durationTime || ''}`},
       
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                          body.treatments = body.treatments.filter(treatment => treatment.id != params.row.id);
                          deleteItem("treatments", body.treatments);
                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];

    const columnsReferrals = [
        { field: 'description', headerName: 'Remitido a:', width: 450 },
        { field: 'observations', headerName: '	Observaciones', width: 450 },
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                        body.referrals = body.referrals.filter(referral => referral.id != params.row.id);
                        deleteItem("referrals", body.referrals);
                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];

    const columnsProcedure = [
        { field: 'description', headerName: 'Procedimiento', width: 200, headerAlign: 'center'  },
        { field: 'quantity', headerName: 'Cantidad', width: 200, align: 'center', headerAlign: 'center' },
        { field: 'requestDate', headerName: 'Fecha Solicitud', width: 200, headerAlign: 'center'  ,
            valueGetter: (params) => 
              `${moment(params.row.requestDate).locale('es').format('MMMM D YYYY')|| ''}`
            },
        { field: 'observations', headerName: 'Observaciones', width: 200, headerAlign: 'center'  },
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                        body.procedures = body.procedures.filter(procedure => procedure.id != params.row.id);
                        deleteItem("procedures", body.procedures);
                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];
 
    return (
       <div>
        <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3 }}>
            <Typography variant="h6">Datos Personales</Typography>
             <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
                <Grid container spacing={1}  >

                    <Grid item xs={12} sm={6} md={4} >
                        <Box color='GrayText' fontSize={20} >
                            Nombre: {props.affiliateInfo.patient.firstName} {props.affiliateInfo.patient.secondName} {props.affiliateInfo.patient.lastName} {props.affiliateInfo.patient.secondLastName}
                          </Box>

                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20} >
                            Identificacion: {props.affiliateInfo.patient.id} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Edad:  {getRealAge(props.affiliateInfo.patient.birthday)} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Direccion:  {props.affiliateInfo.patient.address} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Sexo:  {props.affiliateInfo.patient.gender} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            EPS:  {props.affiliateInfo.patient.eps} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                        <InputLabel id="evolutionsLabel">Evoluciones</InputLabel>
                        <Select
                            labelId="evolutionsLabel"
                            id="evolutions"
                            name="evolutions"
                            defaultValue={-1}
                            label="Evoluciones"
                            onChange={changeOfEvolutions}
                        >
                            <MenuItem value={-1}> Evolucionar  </MenuItem>
                            {previousEvolutions.map((ev,index)=>{
                                return <MenuItem value={index}> {ev.createDate} </MenuItem>;
                                }
                            )}
                           
                        </Select>
                        </Box>
                    </Grid>


                </Grid>
            </Paper>
            
            
            <Typography variant="h6">Generalidades</Typography>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
        {/*<Paper   sx={{p: '50px', borderRadius: '10px', borderColor: 'black', my: 2, mx: 'auto'}} variant="outlined">
            */}
              <form>
                <Grid container spacing={2} > 

                <Grid item xs={12} sm={6} md={4}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='assessmentDate'
                                name='assessmentDate'
                                label="Fecha Valoración de Paciente."
                                inputFormat="MM/dd/yyyy"
                                value={body.assessmentDate}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>
                
                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="externalCauseLabel">Causa Externa</InputLabel>
                                <select
                                    labelId="externalCauseLabel"
                                    id='generalities'
                                    name="externalCause"
                                    disabled={indexEvolution != -1}
                                    value={body.generalities.externalCause}
                                    onChange={handleChange}
                                    label="Causa Externa">
                                    <option value={"OTRA"}>OTRA</option>
                                    <option value={"ACCIDENTES"}>ACCIDENTES</option>                            
                                </select>
                            </div>
                       
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom >Motivo</Typography>
                            <TextField
                                id='generalities'
                                name='reason'
                                value={body.generalities.reason}
                                onChange={handleChange}
                                disabled={indexEvolution != -1}
                                variant='outlined'
                                multiline
                                minRows={5}
                                fullWidth
                                aria-label="minimum height"
                                />
                       
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Enfermedad Actual</Typography>
                            <TextField
                                id='generalities'
                                name='illness'
                                fullWidth
                                value={body.generalities.illness}
                                onChange={handleChange}
                                disabled={indexEvolution != -1}
                                variant='outlined'
                                multiline
                                minRows={5}
                                aria-label="minimum height"
                             />
                       
                    </Grid>
                   
                </Grid>
                </form>
             
            </Paper>
            <Typography  variant="h6">Revision de Sistemas</Typography>
            <Hidden xsUp={props.affiliateInfo.type == "Fisiatria"}>
            <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
            
              <form>
                <Grid container spacing={2} > 
                    <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Síntomas Generales</Typography>
                        <TextField
                            id='systemsReview'
                            name='generalSymptoms'
                            value={body.systemsReview.generalSymptoms}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Sistema Respiratorio</Typography>
                        <TextField
                            id='systemsReview'
                            name='respiratorySystem'
                            value={body.systemsReview.respiratorySystem}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Sistema Cardiovascular</Typography>
                    <TextField
                        id='systemsReview'
                        name='cardiovascularSystem'
                        value={body.systemsReview.cardiovascularSystem}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Sistema Gastrointestinal</Typography>
                    <TextField
                        id='systemsReview'
                        name='gastrointestinalSystem'
                        value={body.systemsReview.gastrointestinalSystem}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Sistema Genitourinario</Typography>
                    <TextField
                        id='systemsReview'
                        name='genitourinarySystem'
                        value={body.systemsReview.genitourinarySystem}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Sistema Endocrino</Typography>
                    <TextField
                        id='systemsReview'
                        name='endocrineSystem'
                        value={body.systemsReview.endocrineSystem}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Sistema Neurológico</Typography>
                    <TextField
                        id='systemsReview'
                        name='neurologicalSystem'
                        value={body.systemsReview.neurologicalSystem}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                  
                        <Button 
                       // type="submit" 
                        variant="contained" 
                        color="primary" 
                        display="inline" 
                        //onClick={() => buttonSave(props)}
                        onClick={() => onSubmit(props, false)}
                        >
                            Actualizar
                        </Button>
                    </Grid>
                 </Grid>
                 </form>
            </Paper>
            </Hidden>
            <Hidden xsUp={props.affiliateInfo.type != "Fisiatria"}>
            <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <form>
              <Grid container spacing={2} > 
                  <Grid item xs={12} sm={12} md={12}>
                      
                      <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Revision de Sistemas</Typography>
                      <TextField
                          id='systemsReview'
                          name='generalSymptoms'
                          value={body.systemsReview.generalSymptoms}
                          onChange={handleChange}
                          disabled={indexEvolution != -1}
                          minRows={3}
                          multiline
                          fullWidth
                          variant='outlined'
                          aria-label="minimum height"
                         />
                 
                  </Grid>
               </Grid>
               </form>
            </Paper>
          </Hidden>

            <Hidden xsUp={props.affiliateInfo.type == "Fisiatria"}>
                <Typography  variant="h6">Signos Vitales</Typography>
                    <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
            
              <form>
                <Grid container spacing={2} > 
                    <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Presión HH</Typography>
                        <TextField
                            id='vitalSigns'
                            name='hhpressure'
                            value={body.vitalSigns.hhpressure}
                            disabled={indexEvolution != -1}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    {/*<Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Presión MM</Typography>
                        <TextField
                            id='vitalSigns'
                            name='pressureMM'
                            value={body.vitalSigns.pressureMM}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>*/}

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Temperatura</Typography>
                    <TextField
                        id='vitalSigns'
                        name='temperature'
                        value={body.vitalSigns.temperature}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Peso (Kg)</Typography>
                    <TextField
                        id='vitalSigns'
                        name='weight'
                        value={body.vitalSigns.weight}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Talla (Cms)</Typography>
                    <TextField
                        id='vitalSigns'
                        name='size'
                        value={body.vitalSigns.size}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>I.M.C</Typography>
                    <TextField
                        id='vitalSigns'
                        name='imc'
                        value={body.vitalSigns.imc}
                        onChange={handleChange}
                        disabled={true}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Périmetro Abdominal</Typography>
                    <TextField
                        id='vitalSigns'
                        name='abdominalPerimeter'
                        value={body.vitalSigns.abdominalPerimeter}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Périmetro Cefálico</Typography>
                    <TextField
                        id='vitalSigns'
                        name='headCircunference'
                        value={body.vitalSigns.headCircunference}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Périmetro Braquial</Typography>
                    <TextField
                        id='vitalSigns'
                        name='brachialPerimeter'
                        value={body.vitalSigns.brachialPerimeter}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Frecuencia Cardiaca</Typography>
                    <TextField
                        id='vitalSigns'
                        name='heartRate'
                        value={body.vitalSigns.heartRate}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Frecuencia Respiratoria</Typography>
                    <TextField
                        id='vitalSigns'
                        name='breathingFrequency'
                        value={body.vitalSigns.breathingFrequency}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                  
                        <Button 
                       // type="submit" 
                        variant="contained" 
                        color="primary" 
                        display="inline" 
                        //onClick={() => buttonSave(props)}
                        onClick={() => onSubmit(props, false)}
                        >
                            Actualizar
                        </Button>
                    </Grid>
                 </Grid>
                 </form>
                    </Paper>
            </Hidden>

            <Typography  variant="h6">Examen Físico</Typography>
            
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
              <form>
                <Grid container spacing={2} > 
                   
                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="stateLabel">Estado en que llegó</InputLabel>
                            <select
                                    labelId="stateLabel"
                                    id="physicalExam"
                                    name="state"
                                    value={body.physicalExam.state}
                                    onChange={handleChange}
                                    disabled={indexEvolution != -1}
                                    label="Estado en que llegó">
                                    
                                    <option value="ALERTA">ALERTA</option>
                                    <option value="CONCIENTE">CONCIENTE</option>
                                    <option value="ESTUPOROSO">ESTUPOROSO</option>
                                    <option value="INCONCIENTE">INCONCIENTE</option>
                                                                       
                                </select>
                            </div>
                       
                    </Grid>
                    <Hidden xsUp={props.affiliateInfo.type != "Fisiatria"}>
                    <Grid item xs={12} sm={12} md={12}>
                       <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Signos Vitales</Typography>
                        <TextField
                           id='vitalSigns'
                           name='hhpressure'
                           value={body.vitalSigns.hhpressure}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        minRows={3}
                        multiline
                        fullWidth
                        variant='outlined'
                        aria-label="minimum height"
                        />
                        </Grid>
                    </Hidden>

                    <Grid item xs={12} sm={12} md={12}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Aspecto General</Typography>
                        <TextField
                            id='physicalExam'
                            name='generalAspect'
                            value={body.physicalExam.generalAspect}
                            disabled={indexEvolution != -1}
                            onChange={handleChange}
                            minRows={3}
                            multiline
                            fullWidth
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cabeza</Typography>
                    <TextField
                        id='physicalExam'
                        name='head'
                        value={body.physicalExam.head}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Agudeza Visual</Typography>
                    <TextField
                        id='physicalExam'
                        name='visualAcuity'
                        value={body.physicalExam.visualAcuity}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cuello</Typography>
                    <TextField
                        id='physicalExam'
                        name='neck'
                        value={body.physicalExam.neck}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Torax (Mamás - Cardiorespiratorio)</Typography>
                    <TextField
                        id='physicalExam'
                        name='chest'
                        value={body.physicalExam.chest}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Abdomen</Typography>
                    <TextField
                        id='physicalExam'
                        name='abdomen'
                        value={body.physicalExam.abdomen}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Genitourinario</Typography>
                    <TextField
                        id='physicalExam'
                        name='genitourinary'
                        value={body.physicalExam.genitourinary}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Osteomuscular</Typography>
                    <TextField
                        id='physicalExam'
                        name='musculoskeletal'
                        value={body.physicalExam.musculoskeletal}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Piel y Faneraz</Typography>
                    <TextField
                        id='physicalExam'
                        name='skin'
                        value={body.physicalExam.skin}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Neurológico</Typography>
                    <TextField
                        id='physicalExam'
                        name='neurological'
                        value={body.physicalExam.neurological}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>
                    <Hidden xsUp={props.affiliateInfo.type != "Fisiatria"}>
                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Gonometria pasiva</Typography>
                    <TextField
                        id='vitalSigns'
                        name='pressureMM'
                        value={body.vitalSigns.pressureMM}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>
                    </Hidden>
                    <Grid item xs={12} sm={12} md={12}>
                  
                        <Button 
                       // type="submit" 
                        variant="contained" 
                        color="primary" 
                        display="inline" 
                        //onClick={() => buttonSave(props)}
                        onClick={() => onSubmit(props, false)}
                        >
                            Actualizar
                        </Button>
                    </Grid>
                 </Grid>
            
               
                 </form>
            </Paper>
            
       
            <Typography  variant="h6">Plan</Typography>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <form>
              <Grid container spacing={2} > 
                 
                  <Grid item xs={12} sm={6} md={6}>
                  
                  <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Descripcion</Typography>
                  <TextField
                      id='plan'
                      name='descriptions'
                      value={body.plan.descriptions}
                      onChange={handleChange}
                      disabled={indexEvolution != -1}
                      variant='outlined'
                      aria-label="minimum height"
                      multiline
                      minRows={5}
                      fullWidth/>
              
                  </Grid>

                  <Grid item xs={12} sm={6} md={6}>
                  
                  <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Observaciones</Typography>
                  <TextField
                      id='plan'
                      name='observations'
                      value={body.plan.observations}
                      onChange={handleChange}
                      disabled={indexEvolution != -1}
                      variant='outlined'
                      aria-label="minimum height"
                      multiline
                      minRows={5}
                      fullWidth/>
              
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => onSubmit(props, false)}
                      >
                          Actualizar
                      </Button>
                  </Grid>
               </Grid>
               </form>
          </Paper>

        <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Button onClick={handleOpen} hidden={indexEvolution != -1} variant="outlined">
             Agregar Diagnostico
            </Button>
            {(open) ? <ModalDiagnoses handleClose={handleClose} addDiagnosis={addDiagnosis}></ModalDiagnoses> : ''}
            
            {(body.diagnoses.length > 0) ?
            <DataGrid
                rows={body.diagnoses}
                columns={columns}
                pagination
                 checkboxSelection={true}
                autoHeight= {true} 
            />: '' }
          </Paper> 

          <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
          <Button  onClick={handleOpenTreatments} hidden={indexEvolution != -1} variant="outlined">
             Agregar Tratamiento
            </Button>
            {(openTreatments) ? <ModalTreatment handleClose={handleClose} addTreatments={addTreatments}></ModalTreatment> : ''}
            
            {(body.treatments.length > 0) ?
          
           <DataGrid
                rows={body.treatments}
                columns={columnsTreatments}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
            />: '' }
           
         
          </Paper>

          <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
          <Button  onClick={handleOpenReferrals} hidden={indexEvolution != -1} variant="outlined">
             Agregar Remisiones
            </Button>
            {(openReferrals) ? <ModalReferral handleClose={handleClose} addReferrals={addReferrals}></ModalReferral> : ''}
            
            {(body.referrals.length > 0) ?
         
           <DataGrid
                rows={body.referrals}
                columns={columnsReferrals}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
                
                />: '' }
           
        
          </Paper>

             <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
          <Button onClick={handleOpenProcedures}hidden={indexEvolution != -1}  variant="outlined">
             Agregar Procedimientos
            </Button>
            
            {(openProcedures) ? <ModalProcedure handleClose={handleClose} addProcedure={addProcedure}></ModalProcedure> : ''}
            {(body.procedures.length > 0) ?
           <DataGrid
                rows={body.procedures}
                columns={columnsProcedure}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
              
              /> : ''}
               
          </Paper>

          <Typography  variant="h6">Escalas</Typography>
          <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
             <Grid container spacing={2} >
                <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="facLabel">SCALA FAC</InputLabel>
                            <select
                                    labelId="facLabel"
                                    id="facID"
                                    name="scoreFAC"
                                    value={body?.scoreFAC}
                                    onChange={handleChangeListItem}
                                    disabled={indexEvolution != -1}
                                    label="SCALA FAC">
                                    <option value="No aplica">No Aplica</option>
                                    <option value="0">No camina o lo hace con ayuda de 2 personas</option>
                                    <option value="1">Camina con gran ayuda de 1 persona</option>
                                    <option value="2">Camina con ligero contacto fisico de 1 persona</option>
                                    <option value="3">Camina con supervision</option>
                                    <option value="4">Camina independiente en llano, no salva escaleras.</option>
                                    <option value="5">Camina indpendiente en llano y salva escaleras</option>
                                  
                                   
                                                                       
                                </select>
                            </div>
                       
                </Grid>
            
                <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="KarnofskyLabel">SCALA KARNOFSKY</InputLabel>
                            <select
                                    labelId="KarnofskyLabel"
                                    id="KarnofskyId"
                                    name="scoreKarnofsky"
                                    value={body?.scoreKarnofsky}
                                    onChange={handleChangeListItem}
                                    disabled={indexEvolution != -1}
                                    label="SCALA KARNOFSKY">
                                    <option value="No aplica">No Aplica</option>
                                    <option value="100">Actividad normal. Sin sintomas ni evidencia de enfermedad</option>
                                    <option value="90">Actividad normal. Signos y sintomas leves de enfermedad</option>
                                    <option value="80">Actividad normal con esfuerzo. Algunos signos o sintomas de enfermedad</option>
                                    <option value="70">Cuida de si mismo pero es incapaz de llevar a cabo una actividad o trabajo normal</option>
                                    <option value="60">Necesita ayuda ocasional de otros pero es capaz de cuidar de si mismo para la mayor parte de sus necesidades</option>
                                    <option value="50">Requiere ayuda considerable de otros y cuidados especiales frecuentes</option>
                                    <option value="40">Incapacitado. Requiere cuidados especiales</option>
                                    <option value="30">Severamente incapacitado. Indicacion de hospitalizacion aunque no hay indicios de muerte inminente</option>
                                    <option value="20">Gravemente enfermo. Necesita asistencia activa de soporte</option>
                                    <option value="10">Moribundo</option>
                                    <option value="0">Fallecido</option>
                                </select>
                            </div>
                       
                </Grid>
            </Grid>
        </Paper>

          <FormGroup>
          <FormControlLabel   label="Necesita Tabla de Barthel?"  control={
           <Checkbox 
           name="useBarthel"
           id='useBarthel'
           checked={body.useBarthel}
           disabled={indexEvolution != -1}
            onChange={activeTableBarthel}
            />
          } />
          </FormGroup>
         <Hidden xsUp={!body.useBarthel}>
            <Typography  variant="h6">Tabla Barthel</Typography>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <form>
              <Grid container spacing={2} > 
               

                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="comerRadioButton">Comer</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="comerRadioButton"
                                        value={body.barthel.comer}
                                        onChange={handleChangeRadioGroup}
                                        disabled={indexEvolution != -1}
                                        name="comer"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Dependiente" />
                                        <FormControlLabel value={5} control={<Radio />} label="Necesita ayuda para cortar, extender mantequilla, usar condimentos, etc." />
                                        <FormControlLabel value={10} control={<Radio />} label="Independiente (capaz de usar cualquier instrumento)" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="traslateRadioButton">Trasladarse entre la silla y la cama</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="traslateRadioButton"
                                        value={body.barthel.translate}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="translate"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Dependiente, no se mantiene sentado" />
                                        <FormControlLabel value={5} control={<Radio />} label="Necesita ayuda importante (1 persona entrenada o 2 personas), puede estar sentado" />
                                        <FormControlLabel value={10} control={<Radio />} label="Necesita algo de ayuda (una pequeña ayuda física o ayuda verbal)" />
                                        <FormControlLabel value={15} control={<Radio />} label="Independiente" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="cleanRadioButton">Aseo personal</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="cleanRadioButton"
                                        value={body.barthel.cleanPersonal}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="cleanPersonal"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Dependiente" />
                                        <FormControlLabel value={5} control={<Radio />} label="Independiente para lavarse la cara, las manos y los dientes, peinarse y afeitarse" />
                             
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="retreteRadioButton">Uso del retrete</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="retreteRadioButton"
                                        value={body.barthel.retrete}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="retrete"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Dependiente" />
                                        <FormControlLabel value={5} control={<Radio />} label="Necesita alguna ayuda, pero puede hacer algo solo" />
                                        <FormControlLabel value={10} control={<Radio />} label="Independiente (entrar y salir, limpiarse y vestirse)" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="bathRadioButton">Bañarse o Ducharse</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="bathRadioButton"
                                        value={body.barthel.bath}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="bath"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Dependiente" />
                                        <FormControlLabel value={5} control={<Radio />} label="Independiente para bañarse o ducharse" />
                                
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="moveRadioButton">Desplazarse</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="moveRadioButton"
                                        value={body.barthel.move}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="move"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Inmóvil" />
                                        <FormControlLabel value={5} control={<Radio />} label="Independiente en silla de ruedas en 50m" />
                                        <FormControlLabel value={10} control={<Radio />} label="Anda con pequeña ayuda de una persona (física o verbal)" />
                                        <FormControlLabel value={15} control={<Radio />} label="Independiente al menos 50 m, con cualquier tipo de muleta, excepto andador" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="escaleraRadioButton">Subir y bajar escaleras</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="escaleraRadioButton"
                                        value={body.barthel.escalera}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="escalera"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Dependiente" />
                                        <FormControlLabel value={5} control={<Radio />} label="Necesita ayuda física o verbal, puede llevar cualquier tipo de muleta" />
                                        <FormControlLabel value={10} control={<Radio />} label="Independiente para subir y bajar" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="dressedRadioButton">Vestirse y desvestirse</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="dressedRadioButton"
                                        value={body.barthel.dressed}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="dressed"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Dependiente" />
                                        <FormControlLabel value={5} control={<Radio />} label="Necesita ayuda, pero puede hacer la mitad aproximadamente, sin ayuda" />
                                        <FormControlLabel value={10} control={<Radio />} label="Independiente, incluyendo botones, cremalleras, cordones, etc." />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="hecesRadioButton">Control de heces</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="hecesRadioButton"
                                        value={body.barthel.heces}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="heces"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Incontinente (o necesita que le suministren enema)" />
                                        <FormControlLabel value={5} control={<Radio />} label="Accidente excepcional (uno/semana)" />
                                        <FormControlLabel value={10} control={<Radio />} label="Continente" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl>
                                    <FormLabel id="orinaRadioButton" className={useStyles.textRadioButton}>Control de orina</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="orinaRadioButton"
                                        value={body.barthel.orina}
                                        disabled={indexEvolution != -1}
                                        onChange={handleChangeRadioGroup}
                                        name="orina"
                                        id='barthel'
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Incontinente, o sondado incapaz de cambiarse la bolsa" />
                                        <FormControlLabel value={5} control={<Radio />} label="Accidente excepcional (máximo uno/24 horas)" />
                                        <FormControlLabel value={10} control={<Radio />} label="Continente durante al menos 7 días" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                    <Typography variant="h6">Score:</Typography>
                                    <Typography variant="h1">{body.barthel.score}</Typography>
                            </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => onSubmit(props, false)}
                      >
                          Actualizar
                      </Button>
                  </Grid>
               </Grid>
               </form>
            </Paper>
          </Hidden>
          <Grid container spacing={2} >
          <Grid item xs={12} sm={6} md={4}>
                
                <Button 
               // type="submit" 
                variant="contained" 
                color="primary" 
                display="inline" 
                //onClick={() => buttonSave(props)}
                onClick={() => {
                    props.setPrintAdditionalInfo(false);
                    if (indexEvolution != -1) {
                        //props.affiliateInfo.evolutions[indexEvolution] = body;
                        props.setIndexEvolution(indexEvolution);
                        props.setAffiliate(props.affiliateInfo);
                        props.changeMenu(12)
                    } else {
                        
                        onSubmit(props, true);
                    }
                    
                    }}>
                    Cerrar Historia
                </Button>
                </Grid>
         </Grid>
        </Box>

<Backdrop
sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
open={openLoader}>
<CircularProgress color="inherit" />
</Backdrop>
</div>
    );
}